import { DateTime } from 'luxon';
const DATE_FORMAT = "yyyy-MM-dd'T'h:mm:ssZZZ";
const DATE_FORMAT_24_HOURS = "yyyy-MM-dd'T'HH:mm:ssZZZ";
const MONTH_FORMAT = 'LLL';
const toLuxonDate = date => (date instanceof Date ? DateTime.fromJSDate(date) : DateTime.fromISO(date));
export const formatDate = date => toLuxonDate(date).toFormat(DATE_FORMAT);
export const getFormattedMonth = date => toLuxonDate(date).toFormat(MONTH_FORMAT);
export const twentyFourFormatDate = date => toLuxonDate(date).toFormat(DATE_FORMAT_24_HOURS);
export const getTodayDate = () => DateTime.now();
export const diffBetweenDates = (date1, date2, units = 'days') => {
    const dateToCheck = toLuxonDate(date1);
    const dateBefore = toLuxonDate(date2);
    return dateToCheck.diff(dateBefore, units).toObject();
};
export const formatLuxonDate = date => toLuxonDate(date).toLocaleString({ month: 'long', day: '2-digit' });
export const formatDateFull = date => toLuxonDate(date).toLocaleString(DateTime.DATE_FULL);
export const addUnitToDate = (date, unit) => toLuxonDate(date).plus(unit);
export const getLuxonNowDate = () => DateTime.now();
export const getFutureDateInDays = days => DateTime.now().plus({ days });
export const daysTill = date => Math.round(toLuxonDate(date).diff(DateTime.now(), 'days').days);
export const isToday = ISODate => {
    const savedDate = DateTime.fromISO(ISODate);
    const today = DateTime.now();
    return savedDate.hasSame(today, 'day');
};
export const parseAndFormatDate = date => {
    // example 'Sun Jan 14 2024 08:53:22 GMT+0200' to 'January 14 2024'
    const parsedDate = DateTime.fromJSDate(new Date(date));
    return parsedDate.toFormat('MMMM d yyyy');
};
